import { render } from "./user_block.vue?vue&type=template&id=1caf099b&scoped=true"
import script from "./user_block.vue?vue&type=script&lang=js"
export * from "./user_block.vue?vue&type=script&lang=js"

import "./user_block.vue?vue&type=style&index=0&id=1caf099b&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caf099b"],['__file',"vue/js/components/shared/user/user_block/user_block.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1caf099b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1caf099b', __exports__)) {
    console.log('reload')
    api.reload('1caf099b', __exports__)
  }
  
  module.hot.accept("./user_block.vue?vue&type=template&id=1caf099b&scoped=true", () => {
    console.log('re-render')
    api.rerender('1caf099b', render)
  })

}


export default __exports__